import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { TermsContent } from '../pages/TermsPage';
import { PrivacyContent } from '../pages/PrivacyPage';
import { RefundContent } from '../pages/RefundPage';
import { CancellationContent } from '../pages/CancellationPage';
import ContactContent from '../components/ContactContent';
import '../pages/LegalPage.css';
import './NativeInfoSheet.css';

const PAGES = {
  terms: TermsContent,
  privacy: PrivacyContent,
  refund: RefundContent,
  cancellation: CancellationContent,
  contact: ContactContent,
};

const LEGAL_HREF = {
  '/terms': 'terms',
  '/privacy': 'privacy',
  '/refund': 'refund',
  '/cancellation': 'cancellation',
  '/contact': 'contact',
};

export default function NativeInfoSheet({ page, title, doneLabel, onClose, onOpenPage }) {
  const Body = PAGES[page];
  if (!Body) return null;

  useEffect(() => {
    const onNativeBack = () => onClose();
    window.addEventListener('rk-native-back', onNativeBack);
    return () => window.removeEventListener('rk-native-back', onNativeBack);
  }, [onClose]);

  const onBodyClick = (e) => {
    const a = e.target.closest?.('a[href]');
    if (!a) return;
    const url = new URL(a.getAttribute('href'), window.location.origin);
    const id = LEGAL_HREF[url.pathname.replace(/\/$/, '') || url.pathname];
    if (!id) return;
    e.preventDefault();
    onOpenPage?.(id);
  };

  return createPortal(
    <div className="ios-sheet" role="dialog" aria-modal="true" aria-labelledby="ios-sheet-title">
      <header className="ios-sheet__bar">
        <button type="button" className="ios-sheet__back" onClick={onClose} aria-label="Back">
          <svg viewBox="0 0 12 20" width="12" height="20" aria-hidden>
            <path d="M10 2L2 10l8 8" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <h1 id="ios-sheet-title">{title}</h1>
        <button type="button" className="ios-sheet__done" onClick={onClose}>
          {doneLabel}
        </button>
      </header>
      <div className="ios-sheet__body legal-body" onClick={onBodyClick}>
        <Body />
      </div>
    </div>,
    document.body,
  );
}
